import LocaleManager from '../utils/LocaleManager.js';
import Config from '../utils/Config.js';
import Utils from '../utils/Utils.js';
import StateButton from '../controls/StateButton.js';
import PopupManager from '../utils/PopupManager.js';
import SoundManager from '../utils/SoundManager.js';

class Slide extends Phaser.Group {
    constructor(game, { maxWidth = 600, title = 'Not defined' } = {})
    {
        super(game, null);

        this.params = { maxWidth, title };
        this._title = LocaleManager.getString(title);

        let dummy = new Phaser.Graphics(game, 0, 0);
        dummy.beginFill(0xFF0000, 0);
        dummy.drawRect(0, 0, maxWidth, 4);
        dummy.endFill();
        this.addChild(dummy);
    }

    set title(value)
    {
        this._title = value;
    }

    get title()
    {
        return this._title;
    }
}

class PaytableSlide extends Slide {
    constructor(game, params = {})
    {
        super(game, params);

        this.title = LocaleManager.getString('help.paytable.title');

        let text = new Phaser.Text(
            game, 0, 0,
            LocaleManager.getString('help.paytable.text'),
            {
                font: Config.DEFAULT_FONT,
                fontSize: 20,
                fontWeight: 'normal',
                fill: '#ffffff',
                wordWrap: true,
                wordWrapWidth: this.params.maxWidth
            }
        );
        text.lineSpacing = -5;
        text.position.set(this.params.maxWidth - text.width >> 1, 0);

        let symbols = [
            {
                id: 1,
                key: 'help.paytable.singer',
                table: Config.PAY_TABLE[1].map((payValue) => `${payValue.lines} - ${payValue.value}`)
            },
            {
                id: 3,
                key: 'help.paytable.guy',
                table: Config.PAY_TABLE[3].map((payValue) => `${payValue.lines} - ${payValue.value}`)
            },
            {
                id: 4,
                key: 'help.paytable.old',
                table: Config.PAY_TABLE[4].map((payValue) => `${payValue.lines} - ${payValue.value}`)
            },
            {
                id: 5,
                key: 'help.paytable.diamond',
                table: Config.PAY_TABLE[5].map((payValue) => `${payValue.lines} - ${payValue.value}`)
            },
            {
                id: 6,
                key: 'help.paytable.raki',
                table: Config.PAY_TABLE[6].map((payValue) => `${payValue.lines} - ${payValue.value}`)
            },
            {
                id: 7,
                key: 'help.paytable.ring',
                table: Config.PAY_TABLE[7].map((payValue) => `${payValue.lines} - ${payValue.value}`)
            },
            {
                id: 8,
                key: 'help.paytable.microphone',
                table: Config.PAY_TABLE[8].map((payValue) => `${payValue.lines} - ${payValue.value}`)
            },
            {
                id: 9,
                key: 'help.paytable.glasses',
                table: Config.PAY_TABLE[9].map((payValue) => `${payValue.lines} - ${payValue.value}`)
            },
            {
                id: 10,
                key: 'help.paytable.teshib',
                table: Config.PAY_TABLE[10].map((payValue) => `${payValue.lines} - ${payValue.value}`)
            }
        ].map((meta) => this.makeSymbol(meta));

        let dX = 0, dY = 0;
        let symbolsContainer = new Phaser.Group(game, null);
        let cols = Config.layout === Config.PORTRAIT ? 2 : 3;
        symbols.forEach((symbol, index) =>
        {
            symbol.position.set(dX, dY);
            dX += symbol.width + 10;
            symbolsContainer.addChild(symbol);

            if ((index + 1) % cols === 0)
            {
                dX = 0;
                dY += symbol.height + 10;
            }
        });

        symbolsContainer.position.set(
            this.params.maxWidth - symbolsContainer.width >> 1,
            0
        );
        this.addChild(symbolsContainer);
        this.addChild(text);
        text.y = symbolsContainer.y + symbolsContainer.height + 4;

    }

    makeSymbol(meta)
    {
        let game = this.game;
        let symbol = new Phaser.Group(game, null);

        let image = new Phaser.Image(game, 0, 0, meta.key);
        symbol.addChild(image);

        let text = new Phaser.Text(
            game, 0, 0,
            meta.table.join('\n'),
            {
                font: Config.DEFAULT_FONT,
                fontSize: 20,
                fontWeight: 'bold',
                fill: '#ffffff',
                wordWrap: true,
                wordWrapWidth: 200
            }
        );
        text.lineSpacing = -5;
        text.anchor.y = 0.5;
        text.position.set(
            image.width + 10,
            image.height >> 1
        );
        symbol.addChild(text);

        return symbol;
    }
}

class PaylinesSlide extends Slide {
    constructor(game, params = {})
    {
        super(game, params);

        this.title = LocaleManager.getString('help.paylines.title');

        let text = new Phaser.Text(
            game, 0, 0,
            LocaleManager.getString('help.paylines.text'),
            {
                font: Config.DEFAULT_FONT,
                fontSize: 20,
                fontWeight: 'normal',
                fill: '#ffffff',
                wordWrap: true,
                wordWrapWidth: this.params.maxWidth
            }
        );
        text.lineSpacing = -5;
        text.position.set(this.params.maxWidth - text.width >> 1, 0);
       
        let maxPaylineRect = { width: 0, height: 0 };
        let paylines = [
            'help.paylines.1-2-3', 'help.paylines.4-5', 'help.paylines.6-7',
            'help.paylines.8-9', 'help.paylines.10-11', 'help.paylines.12-13',
            'help.paylines.14-15', 'help.paylines.16-17', 'help.paylines.18-19',
            'help.paylines.20-21', 'help.paylines.22-23', 'help.paylines.24-25'
        ].map((key) =>
        {
            let payline = new Phaser.Image(game, 0, 0, key);
            payline.anchor.x = 0.5;
            maxPaylineRect.width = Math.max(maxPaylineRect.width, payline.width);
            maxPaylineRect.height = Math.max(maxPaylineRect.height, payline.height);
            return payline;
        });

        let paylinesContainer = new Phaser.Group(game, null);
        let dX = 0, dY = 0;
        let cols = Config.layout === Config.PORTRAIT ? 2 : 3;
        paylines.forEach((payline, index) =>
        {
            payline.position.set(dX, dY);
            paylinesContainer.addChild(payline);
            dX += maxPaylineRect.width + 10;
            if ((index + 1) % cols === 0)
            {
                dX = 0;
                dY += maxPaylineRect.height + 10;
            }
        });
        paylinesContainer.position.set(
            (this.params.maxWidth - paylinesContainer.width >> 1) - paylinesContainer.getLocalBounds().x,
            0
        );
        this.addChild(paylinesContainer);
        this.addChild(text);
        text.y = paylinesContainer.y + paylinesContainer.height - paylinesContainer.getLocalBounds().y

    }
}

class WildScatterSlide extends Slide {
    constructor(game, params = {})
    {
        super(game, params);

        this.title = LocaleManager.getString('help.wild-scatter.title');

        const images = [
            'help.wild-scatter.extra-symbols',
            'help.wild-scatter.guy',
            'help.wild-scatter.singer',
            'help.wild-scatter.old',
            'help.wild-scatter.extra-symbols'
        ].map((key) => new Phaser.Image(game, 0, 0, key));

        const imageWidth = images[1].width;

        const imageContainer = new Phaser.Group(game, this);
        images.reduce((x, image, i) =>
        {
            image.x = x;
            imageContainer.addChild(image);
            return x + image.width;
        }, 0);

        const imageContainerMask = new Phaser.Graphics(game, 0, 0);
        imageContainerMask.beginFill(0xFF0000, 0.5);
        imageContainerMask.drawRect(0, 0, images[1].width, images[1].height);
        imageContainerMask.endFill();
        this.addChild(imageContainerMask);
        setTimeout(() =>
        {
            imageContainer.mask = imageContainerMask;
            let imageIndex = 0;
            const onComplete = () =>
            {
                if (imageIndex === images.length - 1)
                {
                    imageIndex = 0;
                    imageContainer.x = 0;
                    onComplete();
                }
                else
                {
                    imageIndex++;
                    game.add
                        .tween(imageContainer)
                        .to({ x: -imageWidth * imageIndex }, 500, 'Quart.easeOut', false, 3000)
                        .start()
                        .onComplete.addOnce(onComplete);
                }
            };

            onComplete();
        }, 500);

        let wordWrapWidth = Config.layout === Config.PORTRAIT ? this.params.maxWidth : this.params.maxWidth - imageContainerMask.width - 20;

        if (Config.layout === Config.PORTRAIT)
        {
            imageContainerMask.x = wordWrapWidth - imageContainerMask.width >> 1;
        }

        let regularStyle = {
            font: Config.DEFAULT_FONT,
            fontSize: 20,
            fontWeight: 'normal',
            fill: '#ffffff',
            wordWrap: true,
            wordWrapWidth
        };

        let strongStyle = {
            font: Config.DEFAULT_FONT,
            fontSize: 20,
            fontWeight: 'bold',
            fill: '#ffffff',
            wordWrap: true,
            wordWrapWidth
        };

        let texts = [
            { key: 'help.wild-scatter.wild.text', style: regularStyle, lineSpacing: -5 }
            // { key: ['5 - 500', '4 - 250', '3 - 50'].join('\n'), style: strongStyle, lineSpacing: -5 },
            // { key: ['5 - 10', '4 - 5', '3 - 2', '2 - 1'].join('\n'), style: strongStyle, lineSpacing: -5 }
        ].map((meta) =>
        {
            let text = new Phaser.Text(
                game, 0, 0,
                LocaleManager.getString(meta.key),
                meta.style
            );
            text.lineSpacing = meta.lineSpacing;
            return text;
        });

        let textContainer = new Phaser.Group(game, null);
        let dY = 0;
        texts.forEach((text, index) =>
        {
            text.y = dY;
            if ((index + 1) % 2)
            {
                dY += text.height;
            }
            else
            {
                dY += text.height + 20;
                if (Config.layout === Config.PORTRAIT)
                {
                    text.x = wordWrapWidth - text.width >> 1;
                }
            }

            textContainer.addChild(text);
        });

        if (Config.layout === Config.PORTRAIT)
        {
            textContainer.y = imageContainerMask.height + 20;
        }
        else
        {
            textContainer.x = imageContainerMask.width + 20;
        }
        this.addChild(textContainer);
    }
}

class BonusSlide extends Slide {
    constructor(game, params = {})
    {
        super(game, params);

        this.title = LocaleManager.getString('help.bonus.title');

        let text = new Phaser.Text(
            game, 0, 0,
            LocaleManager.getString('help.bonus.text'),
            {
                font: Config.DEFAULT_FONT,
                fontSize: 20,
                fontWeight: 'normal',
                fill: '#ffffff',
                wordWrap: true,
                wordWrapWidth: this.params.maxWidth
            }
        );
        text.lineSpacing = -5;
        text.position.set(this.params.maxWidth - text.width >> 1, 0);
        

        let maxImageRect = { width: 0, height: 0 };
        let images = [
          'help.bonus.bonus', 'help.bonus.game-ui'
        ].map((key) =>
        {
            let image = new Phaser.Image(game, 0, 0, key);
            maxImageRect.width = Math.max(maxImageRect.width, image.width);
            maxImageRect.height = Math.max(maxImageRect.height, image.height);
            return image;
        });

        let imageContainer = new Phaser.Group(game, null);
        this.addChild(imageContainer);

        if (Config.layout === Config.PORTRAIT)
        {
            let dY = 0;
            let maxWidth = this.params.maxWidth
            images.forEach((image) =>
            {
                image.position.set(
                    maxImageRect.width - image.width >> 1,
                    dY
                );
                dY += image.height + 40;
                imageContainer.addChild(image);
            });

            imageContainer.position.set(
                maxWidth - imageContainer.width >> 1,
                0
            );
        }
        else
        {
            let dX = 0;
            images.forEach((image) =>
            {
                image.position.set(
                    dX,
                    maxImageRect.height - image.height >> 1
                );
                dX += image.width + 40;
                imageContainer.addChild(image);
            });

            imageContainer.position.set(
                this.params.maxWidth - imageContainer.width >> 1,
                0
            );
        }
        this.addChild(text);
        text.y = imageContainer.y + imageContainer.height + 20;
    }

}

class DisclaimerSlide extends Slide {
    constructor(game, params = {})
    {
        super(game, params);

        this.title = LocaleManager.getString('help.disclaimer.title');

        let regularStyle = {
            font: Config.DEFAULT_FONT,
            fontSize: 20,
            fontWeight: 'normal',
            fill: '#ffffff',
            wordWrap: true,
            wordWrapWidth: this.params.maxWidth
        };

        let strongStyle = {
            font: Config.DEFAULT_FONT,
            fontSize: 20,
            fontWeight: 'bold',
            fill: '#ffffff',
            wordWrap: true,
            wordWrapWidth: this.params.maxWidth
        };

        let texts = [
            { text: LocaleManager.getString('help.disclaimer.text'), style: regularStyle, lineSpacing: -5 },
            { text: LocaleManager.getString('help.disclaimer1.text'), style: regularStyle, lineSpacing: -5 },
            { text: LocaleManager.getString('help.disclaimer2.text'), style: regularStyle, lineSpacing: -5 },
            { text: LocaleManager.getString('help.disclaimer3.text'), style: regularStyle, lineSpacing: -5 },
            { text: LocaleManager.getString('help.disclaimer4.text'), style: regularStyle, lineSpacing: -5 },
            { text: Config.version, style: strongStyle, lineSpacing: -5 },
        ].map((meta) =>
        {
            const text = new Phaser.Text(game, 0, 0, meta.text, meta.style);
            text.lineSpacing = meta.lineSpacing;
            return text;
        });

        let textContainer = new Phaser.Group(game, null);
        let dY = 0;
        texts.forEach((text, index) =>
        {
            text.y = dY;
            if ((index + 1) % 2)
            {
                dY += text.height;
            }
            else
            {
                dY += text.height + 20;
            }

            textContainer.addChild(text);
        });

        this.addChild(textContainer);
    }
}

export default class HelpPopup extends Phaser.Group {
    constructor(game)
    {
        super(game);

        this.name = 'HelpPopup';
        this.onClose = new Phaser.Signal();

        leanderGMApi.publishEvent(leanderGMApi.publications.PAY_TABLE_STATUS_CHANGED_GAME, true);

        this.redraw();
    }

    checkVisibleSlide()
    {
        let maskSprite = this.maskSprite;
        let scrollPane = this.scrollPane;
        let slides = scrollPane.children;
        let maskSpritePosition = maskSprite.toGlobal(new Phaser.Point());

        let currentSlide = this._isScrolled ? slides.filter((slide) =>
        {
            let slidePosition = slide.toGlobal(new Phaser.Point());
            return slidePosition.y - (slide.height >> 1) <= maskSpritePosition.y;
        }).pop() : slides[0];

        if (currentSlide && currentSlide.title && this._title.text !== currentSlide.title)
        {
            this._title.text = currentSlide.title;
            this.adjustTitle();
        }
    }

    adjustTitle()
    {
        const DEFAULT_FONT_SIZE = 40;
        const title = this._title;
        const bgBounds = this._bg.getBounds();
        bgBounds.width -= this._bg.width - this._closeButton.x;

        title.fontSize = DEFAULT_FONT_SIZE;
        for (let i = 0; i < 10; i++)
        {
            const titleBounds = title.getBounds();
            if (bgBounds.containsRect(titleBounds))
            {
                break;
            }

            title.fontSize -= 2;
        }
    }

    makeInterface()
    {
        let bg = this._bg;
        let game = this.game;

        let closeButton = this._closeButton = new StateButton(game, 0, 0, 'popups.common.close', this.clickHandler, this);
        closeButton.position.set(bg.width - closeButton.width - 20, 20);
        this.addChild(closeButton);

        let headerLine = this._headerLine = new Phaser.Graphics(game, 0, 0);
        headerLine.lineStyle(2, 0xFFFFFF);
        headerLine.lineTo(bg.width * 0.95, 0);
        headerLine.position.set(bg.width - headerLine.width >> 1, 70);
        this.addChild(headerLine);

        let title = this._title = new Phaser.Text(
            game, 0, 0,
            ' ',
            {
                font: Config.DEFAULT_FONT,
                fontSize: 40,
                fontWeight: 'bold',
                fill: '#ffffff'
            }
        );
        title.position.set(
            headerLine.x,
            (headerLine.y - title.height >> 1) + 4
        );
        this.addChild(title);

        switch (Config.layout)
        {
            case Config.LANDSCAPE:
                {
                    let logoImage = new Phaser.Image(game, 0, 0, 'logo');
                    logoImage.position.set(
                        bg.width - logoImage.width >> 1,
                        -logoImage.height - 17
                    );
                    this.addChild(logoImage);
                }
                break;

            case Config.PORTRAIT:
                {
                    let logoImage = new Phaser.Image(game, 0, 0, 'logo');
                    logoImage.scale.set(0.7);
                    logoImage.position.set(
                        bg.width - logoImage.width >> 1,
                        -logoImage.height - 10
                    );
                    this.addChild(logoImage);
                }
                break;
        }

        let scrollUpButton = this._scrollUpButton = new StateButton(game, 0, 0, 'help.arrow-up', this.onScrollUpBtnClick, this);
        let scrollDownButton = this._scrollDownButton = new StateButton(game, 0, 0, 'help.arrow-down', this.onScrollDownBtnClick, this);

        // CREATE TEXT BLOCK
        let scrollPane = this.scrollPane = new Phaser.Group(game);
        scrollPane.position.set(
            Config.layout === Config.PORTRAIT ? headerLine.x + 10 : headerLine.x,
            headerLine.y + 20
        );
        this.addChild(scrollPane);

        // SCROLL BUTTONS
        scrollUpButton.visible = false;
        scrollUpButton.position.set(
            bg.width - scrollUpButton.width - 24,
            scrollPane.y
        );
        this.addChild(scrollUpButton);

        scrollDownButton.visible = false;
        scrollDownButton.position.set(
            scrollUpButton.x,
            bg.height - scrollDownButton.height - 20
        );
        this.addChild(scrollDownButton);

        let scrollPaneMaskSize = this._scrollPaneMaskSize = {
            w: bg.width,
            h: scrollDownButton.y - scrollUpButton.y + scrollUpButton.height
        };

        this.maskSprite = new Phaser.Graphics(this.game, 0, 0);
        this.maskSprite.beginFill(0xFF0000, 0);
        this.maskSprite.drawRect(
            0, 0,
            scrollPaneMaskSize.w, scrollPaneMaskSize.h
        );
        this.maskSprite.position.set(0, scrollPane.y);
        this.addChild(this.maskSprite);

        this._isScrolled = false;

        // ADD MASK WITH A DELAY
        this.scrollPane.visible = false;
        setTimeout(() =>
        {
            this.scrollPane.mask = this.maskSprite;
            this.doScroll(this.scrollPane.y, false);
            this.scrollPane.visible = true;
        }, 100);

        this.scroller = {
            mousedown: false,
            startThreshold: 5
        };

        this.game.input.onUp.add(this.onGameInputUp, this);
        this.game.input.onDown.add(this.onGameInputDown, this);
        this.modeCallbackIndex = this.game.input.addMoveCallback(this.onGameInputMove, this);

        if (Config.ORIENTATION === Config.DESKTOP)
        {
            this.game.input.mouse.mouseWheelCallback = this.onMouseWheel.bind(this);
        }

        let slideClasses = [
            PaytableSlide,
            PaylinesSlide,
            WildScatterSlide,
            BonusSlide,
            DisclaimerSlide
        ];

        let maxSlideWidth = bg.width - scrollDownButton.width * 2 - (Config.layout === Config.PORTRAIT ? 20 : 0);
        let slides = slideClasses.map((slideClass) =>
        {
            return new slideClass(game, { maxWidth: maxSlideWidth });
        });

        slides.reduce((position, element) =>
        {
            element.position.set(0, position);
            scrollPane.addChild(element);
            return position + element.height + 60;
        }, 0);

        this._scrollUpButton.visible = this._scrollDownButton.visible = true;
    }

    onGameInputMove(pointer)
    {
        if (!this.scroller.mousedown)
        {
            return;
        }

        if (Math.abs(this.scroller.y - pointer.y) < this.scroller.startThreshold)
        {
            return;
        }

        let distance = this.scroller.y - pointer.y;
        this.doScroll(this.scrollPane.y - distance, false);
        this.scroller.y = pointer.y;
    }

    onGameInputDown(pointer)
    {
        if (!Phaser.Rectangle.contains(this._bg.getBounds(), pointer.x, pointer.y))
        {
            return;
        }
        this.scroller.mousedown = true;
        this.scroller.y = pointer.y;
    }

    onGameInputUp(event)
    {
        let bgBounds = this._bg.getBounds();
        if (!Phaser.Rectangle.contains(bgBounds, event.x, event.y) && this.scroller.mousedown === false)
        {
            this.clickHandler();
        }

        this.scroller.mousedown = false;
    }

    onMouseWheel(event)
    {
        switch (this.game.input.mouse.wheelDelta)
        {
            case Phaser.Mouse.WHEEL_DOWN:
                this.doScroll(this.scrollPane.y - 24, false);
                break;

            case Phaser.Mouse.WHEEL_UP:
                this.doScroll(this.scrollPane.y + 24, false);
                break;
        }

        event.preventDefault();
    }

    destroy()
    {
        leanderGMApi.publishEvent(leanderGMApi.publications.PAY_TABLE_STATUS_CHANGED_GAME, false);

        if (Config.ORIENTATION === Config.DESKTOP)
        {
            this.game.input.mouse.mouseWheelCallback = null;
        }

        this.game.input.onUp.remove(this.onGameInputUp, this);
        this.game.input.onDown.remove(this.onGameInputDown, this);
        this.game.input.deleteMoveCallback(this.modeCallbackIndex);

        super.destroy();
    }

    updateScroll()
    {
        return;
        let maskSprite = this.maskSprite;
        let scrollPane = this.scrollPane;
        this._scrollUpButton.visible = scrollPane.y < maskSprite.y;
        this._scrollDownButton.visible = maskSprite.height <= scrollPane.y - maskSprite.y;
    }

    onScrollUpBtnClick()
    {
        let y = Math.ceil(this.scrollPane.y + this._bg.height * 0.1);
        this.doScroll(y, false);
    }

    onScrollDownBtnClick()
    {
        let y = Math.floor(this.scrollPane.y - this._bg.height * 0.1);
        this.doScroll(y, false);
    }

    doScroll(position, animate = true)
    {
        let scrollPane = this.scrollPane;
        let scrollPaneMaskSize = this._scrollPaneMaskSize;
        let minScroll = this.maskSprite.y;
        let maxScroll = scrollPane.height > scrollPaneMaskSize.h ? minScroll - scrollPane.height + scrollPaneMaskSize.h : minScroll;

        position = position > minScroll ? minScroll : position;
        position = position < maxScroll ? maxScroll : position;

        if (animate)
        {
            this.game.add.tween(scrollPane).to({ y: position }, 400, Phaser.Easing.Sinusoidal.InOut, true);
        }
        else
        {
            scrollPane.y = position;
        }

        this._scrollUpButton.enabled = position !== minScroll;
        this._scrollDownButton.enabled = position !== maxScroll;

        this.checkVisibleSlide();

        this._isScrolled = true;
    }

    clickHandler()
    {
        this.game.input.onUp.remove(this.onGameInputUp, this);
        SoundManager.playSound('sounds/touch');
        this.onClose.dispatch();
        leanderGMApi.publishEvent(leanderGMApi.publications.PAY_TABLE_STATUS_CHANGED_GAME, false);
    }

    redraw()
    {
        this.removeAll(true, true);
        const game = this.game;

        let bg = this._bg = new Phaser.Graphics(game, 0, 0);
        bg.lineStyle(2, 0xFFFFFF);
        bg.beginFill(0);
        if (Config.layout === Config.PORTRAIT)
        {
            bg.drawRoundedRect(0, 0, Config.GAME_WIDTH - 8, Config.GAME_HEIGHT - 200, 12);
        }
        else
        {
            bg.drawRoundedRect(0, 0, 845, 500, 12);
        }
        bg.endFill();
        this.addChild(bg);

        if (game.cache.checkImageKey('help.arrow-up'))
        {
            this.makeInterface();
        }
        else
        {
            const assetPack = require('../../assets/common/popups/help/asset-pack.json');
            const langPostfix = ['en', 'tr'].indexOf(LocaleManager.locale) !== -1 ? LocaleManager.locale : 'en';
            const bonusUI = assetPack['default'].filter(asset => asset.key === 'help.bonus.game-ui').pop();
            if (bonusUI)
            {
                bonusUI.url = bonusUI.url.replace('game-ui', `game-ui-${langPostfix}`);
            }

            const assetsLoader = game.load.pack('default', null, assetPack);
            assetsLoader.onLoadComplete.addOnce(() => this.makeInterface());
            assetsLoader.start();
        }
    }

    show()
    {
        leanderGMApi.publishEvent(leanderGMApi.publications.PAY_TABLE_STATUS_CHANGED_GAME, true);
    }

    hide()
    {
        this.game.input.onUp.remove(this.onGameInputUp, this);
        leanderGMApi.publishEvent(leanderGMApi.publications.PAY_TABLE_STATUS_CHANGED_GAME, false);
    }

    alignToWorld()
    {
        switch (Config.layout)
        {
            case Config.LANDSCAPE:
                this.position.set(
                    Config.GAME_WIDTH - this.width >> 1,
                    14
                );
                break;

            case Config.DESKTOP:
                this.position.set(
                    (Config.GAME_WIDTH - this.width >> 1) + 1,
                    (Config.GAME_HEIGHT - this.height >> 1) - 8
                );
                break;

            default:
                this.position.set(
                    Config.GAME_WIDTH - this.width >> 1,
                    Config.GAME_HEIGHT - this.height >> 1
                );
        }
    }
}